import { render, staticRenderFns } from "./TariffList.vue?vue&type=template&id=b4efd220&"
import script from "./TariffList.vue?vue&type=script&lang=js&"
export * from "./TariffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports